import CryptoJS from "crypto-js";
var REACT_APP_ENCRYPT_KEY = process.env.REACT_APP_ENCRYPT_KEY;
export var encryptClientId = function (clientId) {
    var _key = CryptoJS.enc.Utf8.parse(REACT_APP_ENCRYPT_KEY);
    var iv = CryptoJS.lib.WordArray.random(128 / 8);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(clientId), _key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
};
